import { asMultiStyleConfig } from '../../../../utils/theme';
export var DetailsCard = asMultiStyleConfig({
  parts: ['container', 'header', 'footer', 'body'],
  defaultProps: {
    colorScheme: 'idle'
  },
  baseStyle: {
    container: {
      boxSizing: 'border-box',
      borderRadius: '0.1875rem',
      boxShadow: '0 0 12px -8px rgba(0, 0, 0, 0.35)',
      position: 'relative'
    },
    header: {
      display: 'flex',
      borderTopLeftRadius: '0.1875rem',
      borderTopRightRadius: '0.1875rem',
      p: {
        base: 5,
        md: 4
      }
    },
    body: {
      pl: {
        base: 5,
        md: 4
      },
      pr: {
        base: 5,
        md: 4
      },
      pb: {
        base: 5,
        md: 4
      }
    },
    footer: {
      px: {
        base: 5,
        md: 4
      },
      py: 4,
      borderBottomLeftRadius: '0.1875rem',
      borderBottomRightRadius: '0.1875rem'
    }
  },
  colorSchemes: {
    idle: {
      container: {
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'grey.300'
      },
      footer: {
        bg: 'grey.1020',
        border: 'grey.200'
      }
    }
  }
});